export default "__VITE_ASSET__DQG90qIt__"